<script>import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { onMount } from "svelte";
import { attrValue, shortId } from "../../utils/html";
export let initialPointOfView = [46.232193, 2.209667];
export let options = {};
export let zoom = 4.5;
export let noZoomControl = false;
export let markers = [];
export let classNames;
export let touchText;
export let scrollText;
export let scrollMacText;
let map;
let id = `map_${shortId()}`;
const resizeMap = () => {
  map && map.invalidateSize();
};
const bindPopup = (m, fn) => {
  let popupComponent;
  m.bindPopup(() => {
    let container = L.DomUtil.create("div");
    popupComponent = fn(container);
    return container;
  });
  m.on("popupclose", () => {
    if (popupComponent) {
      let old = popupComponent;
      popupComponent = null;
      setTimeout(() => {
        old.$destroy();
      }, 500);
    }
  });
  return m;
};
onMount(async () => {
  try {
    const L2 = await import("leaflet");
    const createMarker = (m) => {
      let item = L2.marker([m.lat, m.long], {
        icon: L2.icon({
          iconUrl: "https://wiseed-medias.s3.amazonaws.com/webpages/map-marker.svg",
          iconSize: [48, 48],
          iconAnchor: [25, 40],
          popupAnchor: [0, -30]
        })
      });
      if (m.popupContent) {
        if (typeof m.popupContent == "string") {
          item.bindPopup("<span>" + m.popupContent + "</span>");
        } else {
          let component = m.popupContent;
          item = bindPopup(item, (container) => {
            return new component.component({
              target: container,
              props: { ...component.props }
            });
          });
        }
      }
      return item;
    };
    let { default: GestureHandling } = await import("leaflet-gesture-handling");
    if (GestureHandling) {
      L2.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);
    }
    const opts = {
      preferCanvas: true,
      center: initialPointOfView,
      zoom,
      zoomControl: !noZoomControl,
      gestureHandling: true,
      gestureHandlingText: {
        touch: touchText,
        scroll: scrollText,
        scrollMac: scrollMacText
      },
      ...options
    };
    map = L2.map(id, opts);
    let tileLink = "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}";
    let tileOpt = {
      attribution: "Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ",
      minZoom: 1,
      maxZoom: 16
    };
    L2.tileLayer(tileLink, tileOpt).addTo(map);
    if (markers?.length) {
      let markersLayer = L2.featureGroup();
      markers.forEach((e) => {
        let markerCreated = createMarker(e);
        markerCreated.addTo(markersLayer);
      });
      map = map.addLayer(markersLayer);
    }
  } catch (e) {
    console.error(e);
  }
});
</script>

<svelte:window on:resize={resizeMap} />

<div {id} class={attrValue(['map relative', classNames])}>
	<slot />
</div>

<style>.map{aspect-ratio:1/1;height:100%;width:100%;z-index:1}@media (min-width:768px){.map{aspect-ratio:16/9}}:global(.cluster-marker){background-color:#9597a4;border-radius:50%;color:#fff;font-size:20px;height:40px;line-height:40px;margin-left:-20px;margin-top:-20px;text-align:center;width:40px}</style>
